import type { Location } from '~/core/ts/entity/Location'
import type { Spa, SpaMiniList } from '~/core/ts/entity/Spa'

import HeadMetaBuilder from '~/core/ts/util/HeadMetaBuilder'
import { translate } from '~/core/ts/util/translate'

export function getSpaListPageMetadata(url: string, location?: Location | null, firstSpa?: Spa | SpaMiniList): object {
  const place = location ? location.label : ''

  const title = translate({
    es: `Descubre los mejores balnearios y spas de ${place}`,
    pt: `Descubra os melhores spas e health resorts em ${place}`,
  })

  const subtitle = translate({
    es: 'Realiza tu reserva online al mejor precio y vive una experiencia wellness única ✅',
    pt: 'Reserve online ao melhor preço e desfrute de uma experiência de bem-estar única ✅',
  })

  const desc = `${title}. ${subtitle}`

  const builder = HeadMetaBuilder.create()
    .withTitleAndMetaTitle(title)
    .withMetaDescription(desc)
    .withOpenGraphMeta(title, desc)
    .withTwitterMeta(title, desc)
    .withLink('canonical', url)

  if (firstSpa && firstSpa.images.length > 0) {
    const imageUrl = firstSpa.images[0].url

    builder
      .withTwitterImage(imageUrl)
      .withOpenGraphImage(imageUrl)
      .withThumbnailImage(imageUrl)
  }

  return builder.get()
}

export function getTitle(location?: Location ): string {
  if (!location) {
    return 'Spas'
  }

  return translate({
    es: `Spas en ${location.label}`,
    pt: `Spas em ${location.label}`,
  })
}
